export default __webpack_public_path__ + "static/media/magicpin-icon.d523baf5.png";